var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatHammam = function SvgFeatHammam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: 16.628901,
    height: 16.81473,
    viewBox: "0 0 16.628901 16.81473",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs478"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 16.3039,1.4686288 c -0.14347,-0.026 -0.2554,0.0514 -0.36905,0.1167 -0.68723,0.39494 -1.40226,0.73172 -2.14355,1.01067 -0.43532,0.16381 -0.87915,0.30297 -1.3282,0.42729 -0.41539,0.115 -0.83583,0.20613 -1.25776,0.28747 -0.25348,0.0489 -0.5116,0.0818 -0.76909,0.11385 -0.4773,0.0595 -0.95562,0.0931 -1.43573,0.11394 -0.39412,0.0171 -0.78816,0.009 -1.1821,0.007 -0.25337,-0.002 -0.50762,-0.0161 -0.75964,-0.0424 -0.29587,-0.0309 -0.59181,-0.0636 -0.88733,-0.0986 -0.5947,-0.0705 -1.18153,-0.18318 -1.76081,-0.3259 -0.65254,-0.16076 -1.2956,-0.35909 -1.92235,-0.60647 -0.69546,-0.2745 -1.3718,-0.58881 -2.02628001,-0.95029 -0.0422,-0.0233 -0.0846,-0.0501 -0.13701,-0.0426",
    id: "path441",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 16.13503,0.32878882 c -0.14475,-0.0206 -0.26092,0.0487 -0.38034,0.11539 -1.03556,0.57791998 -2.13935,0.98337998 -3.28221,1.28722998 -0.4624,0.12293 -0.93,0.22319 -1.40318,0.29809 -0.31925,0.0505 -0.63895,0.093 -0.96038,0.1277 -0.38286,0.0414 -0.76633,0.058 -1.15059,0.0733 -0.30976,0.0123 -0.61949,0.0131 -0.92878,0.006 -0.36625,-0.008 -0.73225,-0.0284 -1.09792,-0.0579 -0.29614,-0.0239 -0.59138,-0.0543 -0.88613,-0.089 -0.2331,-0.0274 -0.46577,-0.0623 -0.69651,-0.10529 -0.53218,-0.0991 -1.06146,-0.21282 -1.5832,-0.35808 -0.77103,-0.21466 -1.51967,-0.48975 -2.24961,-0.81947998 -0.32027,-0.14468 -0.63158001,-0.30622 -0.94843001,-0.45701",
    id: "path443",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 4.4411,11.811639 c -0.0631,0.11514 -0.0857,0.2376 -0.0858,0.36939 -6.8e-4,0.77749 -0.006,1.55497 -0.009,2.33246 -3.4e-4,0.10552 10e-4,0.21156 0.0112,0.3165 0.0159,0.16914 0.14266,0.25426 0.27391,0.32603 0.25982,0.14206 0.54642,0.20558 0.83319,0.2646 0.46321,0.0953 0.93234,0.14367 1.40345,0.18163 0.69948,0.0564 1.40017,0.0639 2.10031,0.0474 0.64323,-0.0153 1.28615,-0.0614 1.92061,-0.17747 0.35791,-0.0655 0.71499,-0.14045 1.0452,-0.30425 0.12398,-0.0615 0.24299,-0.12878 0.28407,-0.27469 0.009,-0.0335 0.011,-0.0701 0.011,-0.1053 5.7e-4,-0.89006 4.1e-4,-1.78012 5.5e-4,-2.67018 10e-6,-0.047 7.6e-4,-0.0938 -0.0212,-0.13721",
    id: "path445",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 12.20891,11.969949 c 0,-0.004 0.001,-0.008 -2e-4,-0.0104 -0.0606,-0.10209 -0.0578,-0.20253 -0.0247,-0.31783 0.0496,-0.17322 -0.0538,-0.28006 -0.20705,-0.3477 -0.2535,-0.11191 -0.52212,-0.16853 -0.79186,-0.22071 -0.38023,-0.0736 -0.76602,-0.10601 -1.15048,-0.14662 -0.1855,-0.0196 -0.37271,-0.0233 -0.55921,-0.0331 -0.55907,-0.0293 -1.11874,-0.0271 -1.67806,-0.0189 -0.38734,0.006 -0.77451,0.0254 -1.16122,0.0582 -0.32482,0.0275 -0.64923,0.0565 -0.97046,0.11002 -0.31083,0.0518 -0.62231,0.10505 -0.91852,0.21987 -0.0384,0.0149 -0.0789,0.025 -0.1158,0.0429 -0.2311,0.11189 -0.2736,0.2306 -0.17968,0.49551",
    id: "path447",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 3.74453,14.745669 c -0.16017,0.003 -0.26436,0.11393 -0.37935,0.20132 -0.11012,0.0837 -0.1829,0.1861 -0.18287,0.33694 3e-5,0.12869 0.0547,0.22472 0.14103,0.30503 0.18098,0.16844 0.40287,0.26692 0.63235,0.3491 0.49306,0.17657 1.00407,0.27801 1.51975,0.35882 0.4095,0.0642 0.82158,0.10472 1.2347,0.13858 0.75909,0.0622 1.51957,0.0586 2.27973,0.0484 0.35191,-0.005 0.70406,-0.0276 1.05575,-0.0565 0.33539,-0.0276 0.66989,-0.0607 1.00208,-0.11087 0.61679,-0.0932 1.22702,-0.21714 1.80459,-0.46362 0.16011,-0.0683 0.30058,-0.16717 0.42366,-0.29349 0.19292,-0.19802 0.15293,-0.43943 -0.0343,-0.61148 -0.0704,-0.0647 -0.15785,-0.11074 -0.23943,-0.16275 -0.0776,-0.0495 -0.15823,-0.0112 -0.23393,-0.0342",
    id: "path449",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 14.9002,3.3789188 c 0,0.0246 -2.5e-4,0.0493 5e-5,0.0739 10e-4,0.10724 -0.0135,0.20209 0.11157,0.28146 0.13864,0.088 0.19808,0.26054 0.27839,0.40483 0.27057,0.48607 0.49514,0.99006 0.60301,1.54044 0.0466,0.23749 0.0707,0.47581 0.0739,0.71785 0.0199,1.51273 -0.003,3.02559 0.0121,4.5382402 0.0113,1.13287 10e-4,2.26565 0.008,3.39844 3.1e-4,0.0536 0.004,0.108 -0.021,0.15832",
    id: "path451",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 2.74189,13.542509 c -0.0419,-0.11967 -0.0542,-0.24239 -0.054,-0.3694 0.002,-1.48812 -0.006,-2.9763 0.004,-4.4643502 0.005,-0.70012 0.005,-1.40021 0.006,-2.10029 10e-4,-0.64504 -0.11033,-1.26934 -0.35661,-1.86858 -0.11531,-0.28055 -0.24394,-0.55328 -0.40144,-0.81267 -0.0476,-0.0784 -0.10176,-0.14994 -0.17001,-0.21023 -0.089,-0.0786 -0.12291,-0.077 -0.2109,-4.8e-4 -0.11128,0.0968 -0.18102,0.22561 -0.25074,0.34979 -0.23542,0.4193 -0.44099001,0.85209 -0.57391001,1.31745 -0.10869,0.3805 -0.16649,0.76625 -0.1563,1.16138 0.0225,0.87243 0.0154,1.74508 0.008,2.61741 -0.0156,1.7344202 -0.001,3.4688002 -0.008,5.2031902 -1.9e-4,0.0502 -0.004,0.10106 0.021,0.14775",
    id: "path453",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 14.9002,3.6533288 c -0.1702,0.0654 -0.25245,0.21483 -0.33707,0.35922 -0.30434,0.51935 -0.52894,1.06848 -0.62479,1.66693 -0.0342,0.21386 -0.0621,0.42721 -0.0621,0.64403 3.2e-4,2.29024 -1.2e-4,4.5804802 0.001,6.8707102 6e-5,0.11644 -0.009,0.22932 -0.0537,0.33773",
    id: "path455",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 4.46221,11.801079 c 0.2464,0.0235 0.46632,0.14284 0.7064,0.19342 0.2665,0.0561 0.53292,0.10735 0.80255,0.14628 0.26663,0.0385 0.53381,0.0636 0.80219,0.085 0.2673,0.0213 0.53537,0.0249 0.80196,0.0445 0.32434,0.0238 0.64768,0.009 0.97135,0.0155 0.40867,0.008 0.81732,-0.0149 1.22394,-0.0455 0.62257,-0.047 1.24494,-0.10811 1.84762,-0.29027 0.16831,-0.0509 0.32531,-0.14105 0.50626,-0.14887",
    id: "path457",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 25,
    d: "m 5.79202,10.038549 c 0,-0.8865402 5.5e-4,-1.7730902 -4.7e-4,-2.6596302 -2e-4,-0.16887 0.003,-0.33856 -0.0118,-0.50644 -0.0443,-0.50531 -0.1449,-0.99825 -0.34601,-1.46739 -0.0978,-0.22816 -0.21055,-0.44751 -0.34763,-0.6549 -0.0535,-0.0809 -0.11411,-0.15315 -0.19183,-0.20936 -0.0442,-0.032 -0.0873,-0.0278 -0.13802,0.007 -0.09,0.0624 -0.15092,0.14489 -0.21057,0.2337 -0.35708,0.53172 -0.58308,1.1169 -0.7034,1.74262 -0.0392,0.20387 -0.0549,0.41336 -0.0551,0.62217 -8.5e-4,1.11873 -6e-5,2.23747 -8.7e-4,3.3562002 -9e-5,0.13017 -0.007,0.26033 -0.0101,0.3905",
    id: "path459",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 10.81577,9.8802388 c 0,-0.87247 0.01,-1.74508 -0.003,-2.61737 -0.0113,-0.78353 0.17724,-1.51299 0.53046,-2.20592 0.077,-0.15102 0.14661,-0.30729 0.26466,-0.43201 0.15926,-0.16823 0.17397,-0.17886 0.33411,0.002 0.20458,0.23102 0.3406,0.50871 0.46719,0.78901 0.17379,0.38481 0.29049,0.7882 0.35468,1.20377 0.0299,0.19379 0.0481,0.39171 0.0477,0.59037 -0.002,1.15039 -10e-4,2.30079 -7.3e-4,3.4511802 4e-5,0.0633 0.007,0.12665 0.0101,0.18997",
    id: "path461",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 6.91603,7.6533288 c 0.002,-0.12314 0.008,-0.2464 0.004,-0.36937 -0.0146,-0.49707 0.14092,-0.94652 0.38123,-1.37178 0.20802,-0.36811 0.47574,-0.69074 0.77023,-0.99211 0.0191,-0.0195 0.041,-0.0367 0.0632,-0.0528 0.14303,-0.1041 0.19664,-0.10113 0.32691,0.021 0.35525,0.33313 0.65414,0.71004 0.86424,1.1509 0.18709,0.3926 0.3091,0.80286 0.29767,1.24477 -0.005,0.19337 -8.4e-4,0.38697 -8.4e-4,0.58046",
    id: "path463",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 13.27487,13.468629 c 0.17295,0.0457 0.34155,0.12168 0.52783,0.0744 0.017,-0.004 0.0283,0.007 0.0435,0.0189 0.0944,0.0732 0.20134,0.12272 0.315,0.1608 0.40018,0.13405 0.77688,0.31443 1.10794,0.58036 0.0737,0.0592 0.14642,0.12122 0.21038,0.19046 0.10403,0.11261 0.22928,0.18838 0.37058,0.24165",
    id: "path465",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24,
    d: "m 3.4068,13.479179 c -0.12501,-0.009 -0.24069,0.0355 -0.35854,0.0646 -0.10253,0.0253 -0.21114,-0.007 -0.30433,0.0171 -0.0949,0.0248 -0.17407,0.10861 -0.27613,0.14096 -0.45311,0.14362 -0.86489,0.36578 -1.23455,0.66465 -0.05,0.0404 -0.0943,0.0887 -0.13735,0.13687 -0.10504001,0.11768 -0.23024001,0.20372 -0.38039001,0.2529",
    id: "path467",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: "m 8.2564,8.3076788 c -0.004,0.13006 0.0436,0.24174 0.0941,0.36143 0.0891,0.21122 0.0744,0.42925 -0.0782,0.62016 -0.16819,0.21041 -0.21679,0.43799 -0.11916,0.69764 0.0359,0.0954 0.0776,0.1470502 0.18242,0.1255202",
    id: "path469",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: "m 9.43318,8.3393388 c -10e-4,0.0967 0.0133,0.18328 0.0582,0.27685 0.10532,0.2191 0.10351,0.44405 -0.0472,0.65223 -0.0528,0.0729 -0.10313,0.1474 -0.13817,0.23165 -0.0719,0.17297 -0.0437,0.34131 0.0232,0.5061802 0.0199,0.0489 0.0501,0.0933 0.0512,0.14839",
    id: "path471",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    opacity: 1,
    stroke: "#7f7f7f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 23,
    d: "m 7.11128,8.3393388 c -0.006,0.10425 0.009,0.19923 0.0602,0.29716 0.11852,0.22884 0.0878,0.45453 -0.0609,0.66272 -0.0481,0.0674 -0.0978,0.13161 -0.12689,0.21126 -0.0638,0.1749 -0.0321,0.34168 0.0331,0.5068102 0.0177,0.0448 0.0489,0.0851 0.0418,0.13735",
    id: "path473",
    style: {
      fill: "none",
      fillOpacity: 1,
      strokeWidth: 0.8,
      strokeDasharray: "none"
    }
  }));
};
export default SvgFeatHammam;